import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LanguageContext = createContext();

const STORAGE_KEY = 'language';

const translations = {
  en: {
    searchPlaceholder: 'Search for products...',
    myAccount: 'My Account',
    cart: 'Cart',
    shop: 'Shop',
    continueShopping: 'Continue Shopping',
    proceedCheckout: 'Proceed to Checkout',
    noProducts: 'No products found',
    clearFilters: 'Clear all filters'
  },
  es: {
    searchPlaceholder: 'Buscar productos...',
    myAccount: 'Mi cuenta',
    cart: 'Carrito',
    shop: 'Tienda',
    continueShopping: 'Seguir comprando',
    proceedCheckout: 'Ir a pagar',
    noProducts: 'No se encontraron productos',
    clearFilters: 'Limpiar filtros'
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && translations[saved]) {
        setLanguage(saved);
      }
    } catch {
      // ignore
    }
  }, []);

  const setLang = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
      localStorage.setItem(STORAGE_KEY, lang);
    }
  };

  const value = useMemo(() => ({
    language,
    setLanguage: setLang,
    t: (key) => translations[language]?.[key] || translations.en[key] || key
  }), [language]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
